import { adminOverviewSchema, type AdminOverview } from '@steado/admin-contract/overview';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

/** Dependency probes go stale fast; this is a live reading, not a page. */
export const OVERVIEW_REFETCH_MS = 30_000;

export function overviewQueryOptions(api: ApiClient, days: number) {
  return queryOptions({
    queryKey: ['admin', 'overview', days],
    queryFn: (): Promise<AdminOverview> =>
      api.request({ path: '/admin/overview', query: { days }, schema: adminOverviewSchema }),
    refetchInterval: OVERVIEW_REFETCH_MS,
    placeholderData: (previous) => previous,
  });
}
